import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSortModule, MatSort, Sort } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
// Importar la interfaz y el servicio actualizado
import { SolicitarVisitaService, PagedRequestOptions } from 'src/app/services/solicitar-visita.service';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EspecialidadesService } from 'src/app/services/especialidades.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import Swal from 'sweetalert2';
import { StorageService } from 'src/app/services/storage.service';
// FIX: Asegurar las importaciones de RxJS, incluyendo switchMap y map
import { Subscription, Subject, merge, of as observableOf } from 'rxjs'; 
import { debounceTime, distinctUntilChanged, startWith, catchError, switchMap, map } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as XLSX from 'xlsx';
import { PaginatorIntl } from 'src/app/paginator-intl';
import { SharedModule } from '@app/shared/shared.module';
import { TipoServicioService } from '@app/services/tipo-servicio.service';
import { ClientesService } from 'src/app/services/clientes.service';

@Component({
  selector: 'app-solicitudes-finalizadas',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatSelectModule, SharedModule
  ],
  templateUrl: './solicitudes-finalizadas.component.html',
  styleUrls: ['./solicitudes-finalizadas.component.scss'],
  providers: [
    { provide: MatPaginatorIntl, useClass: PaginatorIntl }
  ]
})
export class SolicitudesFinalizadasComponent implements OnInit, AfterViewInit, OnDestroy {
  dataSource = new MatTableDataSource<any>();
  baseDisplayedColumns: string[] = [
    'id', 
    'local', 
    'zona',
    'especialidad',
    'fechaIngreso',     
    'ticketGruman', 
    'generado_por', 
    'tipoServicio', 
    'tipo_solicitud',
    'observaciones', 
    'tecnico', 
    'acciones'
  ];

  displayedColumns: string[] = [...this.baseDisplayedColumns];

  // Variables de paginación
  totalItems: number = 0;
  pageSize = 10;
  currentPage = 0;
  loading = false;
  
  user: any;
  isReadOnly: boolean = false;

  selectedServiceType: string = '';
  tiposServicio: any[] = [];
  
  selectedCompany: any = null;
  public isGruman: boolean = false;
  public clientes: any[] = [];
  public selectedClientId: number | null = null;
  private companySubscription: Subscription | null = null;
  private searchSubject = new Subject<string>();

  meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  anios: number[] = [];
  selectedMes: string = '';
  selectedAnio: string = '';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('input') input!: ElementRef;

  especialidades: { [key: number]: string } = {};

  constructor(
    private solicitarVisitaService: SolicitarVisitaService,
    private storageService: StorageService,
    private especialidadesService: EspecialidadesService,
    private tipoServicioService: TipoServicioService,
    private clientesService: ClientesService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.user = this.storageService.getCurrentUser();
    this.isReadOnly = this.user?.profile === 'readonly';
  }
  
  ngOnInit(): void {
    this.generarAnios();
    this.cargarEspecialidades();
    this.getTiposServicio();

    // Sincronizar con el cambio de empresa
    this.companySubscription = this.storageService.companyChange$.subscribe((company: any) => {
      this.selectedCompany = company; // Actualizamos la variable local
      this.isGruman = this.selectedCompany?.nombre?.trim().toUpperCase() === 'GRUMAN';
      this.selectedClientId = null;
      if (this.isGruman) {
        this.loadClientes();
      }
      this.updateDisplayedColumns(this.selectedCompany);      
      if (this.paginator) {
          this.paginator.pageIndex = 0; // Reseteamos a la página 1
      }      
      this.loadSolicitudes();         // Recargamos datos
    });

    // Capturar si venimos desde el Dashboard con un mes específico
    this.route.queryParams.subscribe((params: any) => {
      if (params['mesFacturacion']) {
        const parts = params['mesFacturacion'].split(' ');
        if (parts.length === 2) {
          this.selectedMes = parts[0];
          this.selectedAnio = parts[1];
        }
      }
    });

    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(() => {
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
      this.loadSolicitudes();
    });

    const user = this.storageService.getItem('currentUser');
    if (user && user.selectedCompany) {      
      this.selectedCompany = user.selectedCompany;
      // 🛠️ FIX: Inicializar el filtro de cliente en la carga si es GRUMAN
      this.isGruman = this.selectedCompany.nombre?.trim().toUpperCase() === 'GRUMAN';
      this.updateDisplayedColumns(this.selectedCompany);
      if (this.isGruman) {
        this.loadClientes();
      }
    } else {      
      this.updateDisplayedColumns(null);
    }
  }

  // Cargar catálogo de clientes para el dropdown
  loadClientes(): void {
    this.clientesService.getClientesWithGruman().subscribe({
      next: (clientes: any[]) => this.clientes = clientes || [],
      error: (err: any) => console.error('Error al cargar clientes:', err)
    });
  }

  // Evento al seleccionar un cliente en la vista GRUMAN
  onClientFilterChange(): void {
    if (this.paginator) this.paginator.pageIndex = 0;
    this.loadSolicitudes();
  }

  ngAfterViewInit() {
    // Carga los datos cuando el usuario cambia de página o el orden
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(startWith({}))
      .subscribe(() => this.loadSolicitudes());
  }

  ngOnDestroy() {
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
  }

  generarAnios(): void {
    const currentYear = new Date().getFullYear();
    for (let y = 2023; y <= currentYear + 2; y++) {
      this.anios.push(y);
    }
  }

  onDateFilterChange() {
    if (this.paginator) this.paginator.pageIndex = 0;
    this.loadSolicitudes();
  }

  getTiposServicio(): void {
    this.tipoServicioService.findAll().subscribe({
      next: (data: any) => {
        this.tiposServicio = data;
      },
      error: (err: any) => console.error('Error cargando tipos de servicio', err)
    });
  }

  private updateDisplayedColumns(company: any) {
    const newCols = [...this.baseDisplayedColumns];
    let esGruman = false;    
    
    if (company && company.nombre) {      
      const nombreLimpio = company.nombre.trim().toUpperCase();
      if (nombreLimpio === 'GRUMAN') {
        esGruman = true;
      }
    }

    if (esGruman) {
      newCols.splice(1, 0, 'cliente');      
    }

    this.displayedColumns = newCols;
  }

  cargarEspecialidades() {
    this.especialidadesService.findAll().subscribe((data: any[]) => {
      data.forEach(esp => this.especialidades[esp.id] = esp.nombre);
    });
  }

  loadSolicitudes() {
    this.loading = true;

    let mesFacturacionStr = '';
    if (this.selectedMes) mesFacturacionStr += this.selectedMes;
    if (this.selectedAnio) mesFacturacionStr += (mesFacturacionStr ? ' ' : '') + this.selectedAnio;

    // 1. Construir el objeto de opciones para la paginación
    const options: PagedRequestOptions = {
      page: this.paginator.pageIndex + 1,
      limit: this.paginator.pageSize,
      searchTerm: this.input.nativeElement.value,
      serviceType: this.selectedServiceType,
      sortBy: this.sort.active || 'id',
      sortOrder: this.sort.direction || 'desc',
      mesFacturacion: mesFacturacionStr || undefined
    };

    if (this.isGruman) {
      if (this.selectedClientId) {
        options.clientId = this.selectedClientId;
      }
    } else if (this.selectedCompany?.id) {
      options.clientId = this.selectedCompany.id;
    }

    // 2. Llamar al servicio refactorizado con el objeto de opciones
    this.solicitarVisitaService.getSolicitudesFinalizadasPaginado(options)
    .pipe(
      catchError(() => observableOf(null))
    ).subscribe((response: any) => {
      this.loading = false;
      if (response && response.data) {
          this.dataSource.data = response.data;
          this.totalItems = response.total;
      } else {
          this.dataSource.data = [];
          this.totalItems = 0;
      }
    });
  }

  /*loadEspecialidades() {
    this.especialidadesService.findAll().subscribe({
      next: (especialidades: any[]) => {
        this.especialidades = especialidades.reduce((acc, esp) => {
          acc[esp.id] = esp.nombre;
          return acc;
        }, {} as { [key: number]: string });
      }
    });
  }*/
  
  // Evento de cambio de página
  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadSolicitudes();
  }

  // Evento de ordenamiento
  onSortChange(sortState: Sort) {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.loadSolicitudes();
  }

  applyFilter() {
    this.searchSubject.next(this.input.nativeElement.value);
  }

  onServiceTypeChange() {
    this.paginator.pageIndex = 0; // Volvemos a la página 1
    this.loadSolicitudes();       // Recargamos la tabla
  }

  resetFilters() {
    this.input.nativeElement.value = '';
    this.selectedServiceType = '';
    this.selectedClientId = null;
    this.paginator.pageIndex = 0;
    this.sort.active = 'id';
    this.sort.direction = 'desc';
    this.selectedMes = '';
    this.selectedAnio = '';
    this.getTiposServicio();
    this.loadSolicitudes();
  }

  finalizarSolicitud(solicitud: any) {
    this.router.navigate(['/transacciones/solicitudes-de-visita/modificar', solicitud.id]);
  }

  canViewDetail(row: any): boolean {
    if (row.facturacion && (row.facturacion.is_cerrada === true || row.facturacion.is_cerrada === 1)) {
      return false;
    }
    return true;
  }
  
  verSolicitud(element: any) {
    this.router.navigate(['/transacciones/solicitudes-de-visita/ver-solicitud/aprobada', element.id]);
  }

  exportarExcel() {
    Swal.fire({
      title: 'Generando exportación...',
      text: 'Esto puede tardar unos segundos, por favor espera.',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    let mesFacturacionStr = '';
    if (this.selectedMes) mesFacturacionStr += this.selectedMes;
    if (this.selectedAnio) mesFacturacionStr += (mesFacturacionStr ? ' ' : '') + this.selectedAnio;

    // 1. Construir las opciones (Inyectamos el status directamente por seguridad)
    const options: PagedRequestOptions | any = {
      export: true,
      searchTerm: this.input.nativeElement.value,
      serviceType: this.selectedServiceType,
      sortBy: this.sort.active || 'id',
      sortOrder: this.sort.direction || 'desc',
      mesFacturacion: mesFacturacionStr || undefined,
      status: 'finalizada'
    };

    if (this.isGruman) {
      if (this.selectedClientId) {
        options.clientId = this.selectedClientId;
      }
    } else if (this.selectedCompany?.id) {
      options.clientId = this.selectedCompany.id;
    }

    // 2. Llamada al servicio
    this.solicitarVisitaService.descargarExcelSolicitudes(options).subscribe({
      next: (response: any) => {
        if (!response || !response.data || response.data.length === 0) {
          Swal.fire('Sin datos', 'No hay solicitudes rechazadas para exportar.', 'warning');
          return;
        }

        // 3. Delegar la generación del Excel al servicio maestro
        this.solicitarVisitaService.exportarExcelMaestro(response.data, 'Finalizadas');
      },
      error: (err: any) => {
        console.error('Error al exportar:', err);
        Swal.close();
        Swal.fire('Error', 'Hubo un problema al generar el Excel.', 'error');
      }
    });
  }
}